export enum HttpHeaderType {
    JSON = 0,
    FORM_DATA = 1,
}